const counter = {
    counter: document.getElementById('counter'),
    init() {
      this.setCounter();
    },
    setCounter() {
      if (!this.counter) return;
      const setDate = this.counter.dataset.date as string;
  
      const date = new Date(setDate);
      if (!this.isValidDate(date, setDate)) return;
      this.displayRemainingTime(date);
    },
    displayRemainingTime(date: Date) {
      const intervalId = setInterval(() => {
        const remainingTime = this.getTimeRemaining(date);
  
        if (
          remainingTime.days === 0 &&
          remainingTime.hours === 0 &&
          remainingTime.minutes === 0 &&
          remainingTime.seconds === 0
        ) {
          clearInterval(intervalId);
        }
        this.counter!.innerHTML = `${remainingTime.days} <span>days</span> ${remainingTime.hours} <span>hrs</span> ${remainingTime.minutes} <span>min</span> ${remainingTime.seconds} <span>sec</span>`;
      }, 1000);
    },
    getTimeRemaining(date: Date): {
      days: number;
      hours: number;
      minutes: number;
      seconds: number;
    } {
      const currentDate = new Date();
  
      const timeDifference = date.getTime() - currentDate.getTime();
  
      if (timeDifference < 0) {
        return {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
        };
      }
  
      const seconds = Math.floor(timeDifference / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);
  
      return {
        days: days,
        hours: hours % 24,
        minutes: minutes % 60,
        seconds: seconds % 60,
      };
    },
    isValidDate(date: Date, string: string) {
      return !isNaN(date.getTime()) && date.toISOString().slice(0, 10) === string;
    },
  };
  
  export default counter;